module.exports = __webpack_public_path__ + "static/media/dewpoint.194b286c.svg";